export default __webpack_public_path__ + "static/media/Barb.071de76e.mp3";